import { activeThemeSelector, Small } from '@meterup/atto';
import { isDefined } from '@meterup/common';
import React from 'react';

import { colors, fontWeights, styled } from '../stitches';

const Container = styled('div', Small, {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '$20',
  height: '$20',
  overflow: 'hidden',
  color: '$$foregroundColor',
  fontWeight: fontWeights.bold,
  [activeThemeSelector]: {
    $$backgroundColor: colors.white,
    color: '$$foregroundColor',
  },
  variants: {
    size: {
      small: {
        width: '$20',
        minWidth: '$20',
        height: '$20',
        minHeight: '$20',
        letterSpacing: '-0.05em',
        fontSize: 10,
      },
      medium: {
        width: '$28',
        minWidth: '$28',
        height: '$28',
        minHeight: '$28',
        fontSize: 12,
      },
      large: {
        width: '$64',
        minWidth: '$64',
        height: '$64',
        minHeight: '$64',
        fontSize: 24,
      },
    },
    color: {
      brand: {
        $$backgroundColor: colors.brand50,
        $$foregroundColor: colors.brand800,
      },
      blue: {
        $$backgroundColor: colors.blue50,
        $$foregroundColor: colors.blue800,
      },
      green: {
        $$backgroundColor: colors.green50,
        $$foregroundColor: colors.green800,
      },
      red: {
        $$backgroundColor: colors.red50,
        $$foregroundColor: colors.red800,
      },
    },
  },
});

const StyledSVG = styled('svg', {
  position: 'absolute',
  inset: 0,
  fill: '$$backgroundColor',
  zIndex: 0,
});

const Initials = styled('span', {
  zIndex: 1,
});

const getInitials = (email: string, firstName?: string, lastName?: string) =>
  isDefined(firstName) && isDefined(lastName) ? firstName[0] + lastName[0] : email.slice(0, 2);

const colorSets = ['brand', 'blue', 'green', 'red'] as const;

const getColor = (email: string) => colorSets[email.charCodeAt(0) % 4];

export function UserProfilePicture({
  email,
  firstName,
  lastName,
  size = 'small',
}: {
  email: string;
  firstName?: string;
  lastName?: string;
  size?: 'small' | 'medium' | 'large';
}) {
  const color = getColor(email);
  return (
    <Container color={color} size={size}>
      <StyledSVG viewBox="0 0 20 20">
        <path d="M20 10C20 6.58894 19.7675 2.74054 18.5175 1.48688C17.2675 0.233235 12.7907 0 10.0291 0C7.26743 0 2.79072 0.233235 1.5407 1.48688C0.290696 2.74054 0 6.58894 0 10C0 13.4111 0.2907 17.2595 1.5407 18.5131C2.79072 19.7668 7.26743 20 10.0291 20C12.7907 20 17.2674 19.7668 18.5174 18.5131C19.7675 17.2595 20 13.4111 20 10Z" />
      </StyledSVG>
      <Initials>{getInitials(email, firstName, lastName)}</Initials>
    </Container>
  );
}
